import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";

const stripeApi = (() => {
  let stripe = null;

  return {
    async checkout(priceId) {
      if (!priceId) {
        throw new Error("invalid args");
      }
      if (stripe === null) {
        stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
      }

      const params = {
        price: priceId,
      }

      const session = await axios.get(`/api/tenant/stripe/checkout`, { params });
      if (session.data.id) {
        await stripe.redirectToCheckout({ sessionId: session.data.id });
      }
      return session.data;
    },
    async customerPortal() {
      const response = await axios.get(`/api/tenant/stripe/customer_portal`);
      return response.data;
    },
    async getPrices() {
      const response = await axios.get(`/api/shared/stripe/price`);
      return response.data;
    },
    async getPromotion(code) {
      const response = await axios.get(`/api/shared/stripe/promotion/${code}`);
      return response.data;
    },
    async getTaxes() {
      const response = await axios.get(`/api/shared/stripe/tax`);
      return response.data;
    },
    async getCustomerInfo() {
      const response = await axios.get(`/api/tenant/stripe/customer`);
      return response.data;
    },
    /**
     * @param {Object} data
     * @param {String} data.priceId
     * @param {String} data.paymentMethodId
     * @param {String} data.quantity
     * @param {String} data.promotionId
     * @returns {Promise<any>}
     */
    async createSubscription(data) {
      const response = await axios.post('/api/tenant/stripe/subscription', data);
      return response.data;
    }
  }
})();

export default stripeApi;
